<template>
  <div class="hello">
    <div class="search container-fluid">
      <input @input="searchUtilisateurs(currentPage)" v-model="searchTerm" type="text" placeholder="Rechercher un utilisateur...">
    </div>
   
    <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchUtilisateurs(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>
    <div class="links container-fluid">
      <RouterLink to="/ajout-compte"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>
      </svg>Ajouter un compte</RouterLink>
    </div>
    <div v-if="confirmationMessage" class="alert alert-success" role="alert">
      {{ confirmationMessage }}
    </div>

    <div v-if="utilisateurs.length === 0" class="user-card no-users">
      Pas d'utilisateurs enregistrés.
    </div>
    <div v-else class="row">
      <div v-for="utilisateur in utilisateurs" :key="utilisateur.id" class="col-12 col-md-6 col-xl-4 mb-4">
        <div class="user-card" :class="{ 'user-inactive': !utilisateur.actif }">
          <div class="card-header">
            <div class="user-name">
              <strong>{{ utilisateur.nom }} {{ utilisateur.prenom }}</strong>
            </div>
            <div class="card-actions">
              <a v-if="utilisateur.actif" href="#" @click.prevent="basculerActivation(utilisateur)" title="Mettre en veille"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pause-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"/>
              </svg></a>
              <a v-else href="#" @click.prevent="basculerActivation(utilisateur)" title="Réactiver le compte"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-play-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
              </svg></a>
              <a href="#" @click.prevent="openPopup(utilisateur)" title="Modifier"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg></a>
              <a href="#" @click="supprimerUtilisateur(utilisateur)" title="Supprimer"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg></a>
            </div>
          </div>
          <div class="card-body">
            <div class="content">
              <div class="card-infos">
                <span class="info-chip" :class="utilisateur.actif ? 'chip-actif' : 'chip-veille'">Statut : <strong>{{ utilisateur.actif ? 'Actif' : 'En veille' }}</strong></span>
                <span class="info-chip">Email : <strong>{{ utilisateur.email }}</strong></span>
                <span class="info-chip">Rôle : <strong>{{ utilisateur.role }}</strong></span>
                <span class="info-chip">Client : <strong>{{ utilisateur.nom_client }}</strong></span>
                <span class="info-chip">Magasin : <strong>{{ utilisateur.nom_magasins }}</strong></span>
                <span class="info-chip">Dernière connexion : <strong>{{ utilisateur.last_login ? formatDate(utilisateur.last_login) : 'Pas de connexion' }}</strong></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchUtilisateurs(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>
  </div>

    <!-- Popup à la fin du template -->
    <div v-if="popupOpen" class="popup" @click="closePopup">
      <div class="popup-content" @click.stop>
        <div class="popup-header">
          <h2>Modifier l'utilisateur</h2>
          <a class="close-button" @click="closePopup">&times;</a>
        </div>
        <div class="popup-body inscription">
          <form  @submit.prevent="sauvegarderUtilisateur">
            <div class="half">
              <div>
                <label for="nom">Nom</label>
                <input type="text" id="nom" v-model="utilisateurModif.nom" required>
              </div>
              <div>
                <label for="prenom">Prénom</label>
                <input type="text" id="prenom" v-model="utilisateurModif.prenom" required>
              </div>
            </div>
            <div>
              <label for="email">Email</label>
              <input type="email" id="email" v-model="utilisateurModif.email" required>
            </div>
            <div>
              <label for="password">Mot de passe</label>
              <div class="passContainer">
                  <input type="password" id="password">
                  <span @click="togglePasswordVisibility">
                      <svg v-if="showPass == 0" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                      <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
                      <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
                      </svg>
                  </span>
              </div>
            </div>
            <div>
              <label for="role">Rôle</label>
              <select id="role" v-model="utilisateurModif.role" required>
                <option value="admin">Administrateur</option>
                <option value="gestion">Gestion</option>
                <option value="production">Production</option>
                <option value="be">Bureaux d'étude</option>
                <option value="achats">Achats</option>
                <option value="client">Client</option>
                <option value="reception">Réception</option>
                <option value="approvisionnement">Approvisionnement</option>
                <option value="comptabilite">Comptabilité</option>
              </select>
            </div>
            <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
            </svg>Modifier l'utilisateur</button>
            <div v-if="confirmationMessage1" class="alert alert-success" role="alert">
              {{ confirmationMessage1 }}
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'



export default {
  data() {
    return {
      utilisateurs: [],
      nb_pages:1,
      currentPage: 1,
      searchTerm: '',
      isLoading: false,
      confirmationMessage: '',
      confirmationMessage1: '',
      popupOpen: false,
      utilisateurModif: null,
    }
  },
  mounted() {
    

      this.currentPage = parseInt(this.$route.query.page) || 1;
      this.searchTerm = this.$route.query.searchTerm || '';

      this.searchUtilisateurs(this.currentPage);

  }, 
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchTerm = to.query.searchTerm || '';

      this.searchUtilisateurs(this.currentPage);
    }

    
  },
  methods: {
    getUserLink(utilisateur) {
      // Create the base URL

      var userName =  utilisateur.nom.replace(/\//g, "%2F");
      var userLastname =  utilisateur.prenom.replace(/\//g, "%2F");
      var userRole =  utilisateur.role.replace(/\//g, "%2F");
      let url = '/utilisateur/' + userName + '/' + userLastname + '/' + userRole;

      // Add the optional parameters if they are not empty
      if (this.currentPage) {
        url += '/' + this.currentPage;
      } else {
        url += '/empty';
      }
      if (this.searchTerm) {
        url += '/' + this.searchTerm;
      } else {
        url += '/empty';
      }
      // Return the final URL
      return url;
    },
    searchUtilisateurs(page) {
      this.isLoading = true; // Show loader
      axios.get(`https://www.simef.fr/espace-client/api/getUtilisateurs.php?page=${page}&searchTerm=${this.searchTerm}`)
        .then(response => {
          this.utilisateurs = response.data.utilisateurs;
          this.nb_pages = response.data.nb_pages;
          this.currentPage = page;

        })
        .catch(error => {
          console.error(error);
          

        })
        .finally(() => {
          this.isLoading = false; // Hide loader
        });

        this.$router.push({
          query: {
            page: page,
            searchTerm: this.searchTerm,
          }
        });
    },
    supprimerUtilisateur(utilisateur) {
      const confirmation = confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?");

      if (confirmation) {
        axios
          .post('https://www.simef.fr/espace-client/api/deleteUser.php', {
            email: utilisateur.email
          })
          .then(response => {
            this.confirmationMessage = response.data.success;
            this.searchUtilisateurs(this.currentPage);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    // Mise en veille / réactivation d'un compte (intérimaires notamment) :
    // le compte est conservé, mais l'accès à l'application est suspendu
    basculerActivation(utilisateur) {
      const nouvelEtat = !utilisateur.actif;
      const question = nouvelEtat
        ? `Réactiver le compte de ${utilisateur.nom} ${utilisateur.prenom} ?`
        : `Mettre en veille le compte de ${utilisateur.nom} ${utilisateur.prenom} ? Il ne pourra plus se connecter tant qu'il n'est pas réactivé.`;

      if (!confirm(question)) return;

      axios
        .post('https://www.simef.fr/espace-client/api/toggleUtilisateur.php', {
          id: utilisateur.id,
          actif: nouvelEtat
        })
        .then(response => {
          if (response.data.error) {
            alert(response.data.error);
            return;
          }
          utilisateur.actif = response.data.actif;
          this.confirmationMessage = response.data.success;
        })
        .catch(error => {
          console.log(error);
        });
    },
    openPopup(utilisateur) {
      this.utilisateurModif = utilisateur;

      this.popupOpen = true;
    },

    closePopup() {
      event.stopPropagation();
      this.popupOpen = false;
    },
    togglePasswordVisibility() {
        const passwordInput = document.getElementById('password');
        if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
            this.showPass = 1;
        } else {
            passwordInput.type = 'password';
            this.showPass = 0;
        }
    },
    sauvegarderUtilisateur() {
      // Récupérer la valeur du champ de saisie du mot de passe
      const nouveauMotDePasse = document.getElementById('password').value;
      if (nouveauMotDePasse.trim() !== '') {
        axios.post('https://www.simef.fr/espace-client/api/modifierUtilisateur.php', {
            id: this.utilisateurModif.id,
            mail: this.utilisateurModif.email,
            password: nouveauMotDePasse,
            role: this.utilisateurModif.role,
            nom: this.utilisateurModif.nom,
            prenom: this.utilisateurModif.prenom,
        })
        .then(response => {
          this.confirmationMessage1 = response.data.success1;
        })
        .catch((error) => {
            console.log(error);
        });
      } else {
        axios.post('https://www.simef.fr/espace-client/api/modifierUtilisateur.php', {
            id: this.utilisateurModif.id,
            mail: this.utilisateurModif.email,
            role: this.utilisateurModif.role,
            nom: this.utilisateurModif.nom,
            prenom: this.utilisateurModif.prenom,
        })
        .then(response => {
          this.confirmationMessage1 = response.data.success1;
        })
        .catch((error) => {
            console.log(error);
        });
      }
    },
    formatDate(dateString) {
      const dateObj = new Date(dateString);
      const day = dateObj.getDate();
      const month = dateObj.getMonth() + 1; // Les mois commencent à 0
      const year = dateObj.getFullYear();
      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes();
      const seconds = dateObj.getSeconds();
      
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
  
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  select {
    background: #f5f5f5;
    border: 0px;
    padding: 12px 15px;
    border: 1px solid lightgrey;
    margin-right: 10px;
  }
  #loading {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  button {
    background: $primary;
    border: none;
    padding: 12px 20px;
    color: #fff;
  }
  .check {
    margin-right: 10px;
  }
 

  table.utilisateursListe {
    width: 100%;
    tbody {

        
      
      a {
        font-size: 0.9rem;
        color: #2b358d;
        display: contents;
      }
    }
    thead {
      background: #2b358d!important;
      color: #fff!important;
      position: sticky;
      top: 0px;
    }
    th, td {
      padding: 8px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #1d1d20;
    }
  
    th {
      color: #fff!important;
    }
    .ligne-claire {
      background-color: #f7f7f7;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }
  }
  
  .search {
      @media screen and (max-width:992px) {
        input[type="text"] {
            margin-bottom: 10px;
        }
      }
  }


  .text-danger {
    color: rgb(255, 17, 17);
  }
  .search {
    input[type="text"], select {
        background: #f5f5f5;
        border: 0px;
        padding: 12px 20px;
        border: 1px solid lightgrey;
        margin-right: 10px;
        &:focus-visible {
          outline: $primary auto 1px;
          border-color: $primary;
          border-radius: 0px;
        }
    }
  }
  .loader {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #0b0b0baa;
    top: 0;
    left: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
z-index: 99999;
  }
  .archiver {
    a {
      height: 100%;
      width: 100%;
      display: flex!important;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
        height: 18px;
        widows: 18px;
      }
    }
  }
  .profil-picture {
      svg {
        height: 18px;
        width: 18px;
        path {
          fill: #333;
        }
      }
  }
  .links {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-bottom: 8px;
    flex-wrap: wrap;
    @media screen and (max-width:992px) {
      justify-content: center;
    }
    a {
      border: none;
      color: #2b358d;
      text-decoration: none;
      display: inline-block;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
     
      svg {
        margin-right: 10px;
      }
      &:hover {
        color: #6e8eee;
      }
    }
  }
  .utilisateur-header-card {
    display: flex;
    background: #2b358d;
    color: #fff;
    font-weight: 700;
    border-radius: 0;
    padding: 12px 0 12px 0;
    margin-bottom: 0px;
    > div {
      flex: 1 1 0;
      text-align: center;
      font-size: 1rem;
      &:first-child {
        flex: 0 0 48px;
      }
      &.actions {
        flex: 0 0 120px;
      }
    }
  }
  .user-card {
    background: #fff;
    border: 1px solid #cbcbcb;
    border-radius: 0px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    min-height: 180px;
    position: relative;
    transition: box-shadow 0.2s;
    width: 100%;
    box-shadow: 0 4px 16px rgba(43,53,141,0.08);
    &:hover {
      box-shadow: 0 4px 16px rgba(43,53,141,0.15);
    }
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0px!important;
      background: #2b358d;
      padding: 10px 20px;
      color: #fff;
      .user-name {
        font-size: 1.1rem;
        font-weight: 700;
        color: #fff;
      }
      
    }
    .card-body {
      display: flex;
      height: 100%;
      .content {
        width: 100%;
        padding: 15px;
      }
    }
    .card-infos {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 8px;
      flex-direction: column;
    }
    .info-chip {
      background: #f5f5f5;
      border-radius: 12px;
      padding: 4px 10px;
      font-size: 0.9rem;
      color: #1d1d20;
      display: flex;
      align-items: center;
      font-weight: 600;
      gap: 3px;
      &.chip-actif {
        background: #e6f4ea;
        color: #1e6b38;
      }
      &.chip-veille {
        background: #fdecec;
        color: #a12626;
      }
    }
    // Compte en veille : la carte est grisée, seul l'en-tête reste lisible
    &.user-inactive {
      opacity: 0.75;
      .card-header {
        background: #6b6f8c;
      }
    }
    &.no-users {
      justify-content: center;
      color: #888;
      font-size: 1.1rem;
      padding: 32px 0;
      box-shadow: none;
      border: none;
      background: none;
    }
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 998!important;
  }
  .popup-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 600px;
    width: 90vw;
    max-height: 90vh;
    background: #f2f2f2 !important;
    padding: 40px 32px;
    color: #1d1d20;
    z-index: 9999;
    overflow-y: auto;
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(43,53,141,0.18);
    @media screen and (max-width:992px) {
      max-width: 95vw;
      padding: 20px 5vw;
    }
    p {
      color: #1d1d20;
    }
  }
</style>
